import { useState } from 'react';

interface ImageItem {
  image: string;
  alt?: string;
  link?: string;
}

interface Props {
  images?: ImageItem[];
  imageWidth?: number;
  imageHeight?: number;
  gap?: number;
  maxWidth?: string;
  backgroundColor?: string;
  padding?: string;
  borderRadius?: number;
  [k: string]: unknown;
}

const ImageRow = (props: Props) => {
  const {
    images,
    imageWidth = 160,
    imageHeight = 120,
    gap = 32,
    maxWidth,
    backgroundColor,
    padding,
    borderRadius,
  } = props;

  const containerStyle: React.CSSProperties = {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: `${gap}px`,
    maxWidth: maxWidth || undefined,
    margin: '0 auto',
    backgroundColor: backgroundColor || undefined,
    padding: padding || undefined,
  };

  if (!images || images.length === 0) {
    return (
      <div style={containerStyle}>
        <p style={{ color: '#999', fontFamily: 'GT-Walsheim-Pro-Regular, sans-serif' }}>
          Add images in the Builder editor
        </p>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      {images.map((item, index) => {
        if (!item.image) return null;
        return (
          <ImageRowItem
            key={index}
            item={item}
            imageWidth={imageWidth}
            imageHeight={imageHeight}
            borderRadius={borderRadius}
          />
        );
      })}
    </div>
  );
};

interface ImageRowItemProps {
  item: ImageItem;
  imageWidth: number;
  imageHeight: number;
  borderRadius?: number;
}

const ImageRowItem = ({ item, imageWidth, imageHeight, borderRadius }: ImageRowItemProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const imgStyle: React.CSSProperties = {
    width: `${imageWidth}px`,
    height: `${imageHeight}px`,
    objectFit: 'contain',
    transform: isHovered ? 'scale(1.06675)' : 'scale(1)',
    transition: 'transform 0.3s ease',
    borderRadius: borderRadius !== undefined ? `${borderRadius}px` : undefined,
  };

  const img = (
    <img
      src={item.image}
      alt={item.alt || 'image'}
      style={imgStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    />
  );

  if (item.link) {
    return (
      <a
        href={item.link}
        target='_blank'
        rel='noopener noreferrer'
        style={{ display: 'inline-flex', textDecoration: 'none' }}
      >
        {img}
      </a>
    );
  }

  return img;
};

export default ImageRow;
